import React from "react";


const CheckboxGroup = ({ input, meta, options, label }) => {
  const handleChange = (value) => {
    const currentValues = Array.isArray(input.value) ? input.value : [];
    const newValues = currentValues.includes(value)
      ? currentValues.filter((v) => v !== value)
      : [...currentValues, value];
    input.onChange(newValues);
  };

  return (
    <div className="checkbox-group-wrapper">
      {label && <label >{label}</label>}
      <div className="checkbox-modern-wrapper">
        {options.map((option, index) => {
          const value = typeof option === "string" ? option : option.value;
          const display = typeof option === "string" ? option : option.label;
          const checked = Array.isArray(input.value) && input.value.includes(value);

          return (
            <label key={index} className={`checkbox-modern ${checked ? "checked" : ""}`}>
              <input
                type="checkbox"
                value={value}
                checked={checked}
                onChange={() => handleChange(value)}
              />
              <span className="checkmark"></span>
     
            </label>
          );
        })}
      </div>
      {meta.touched && meta.error && <div className="text-danger mt-1 small">{meta.error}</div>}
    </div>
  );
};

export default CheckboxGroup;